import ViewProformaSales from "../../../../components/@documents/proforma_sales/ViewProformaSales";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ProformaSalesViewPage() {

    return (
        <ViewProformaSales 
            routeType={routeTypes.admin}
        />
    )
}